import { render, staticRenderFns } from "./HomeMenu.vue?vue&type=template&id=5734fa15&scoped=true"
import script from "./HomeMenu.vue?vue&type=script&lang=js"
export * from "./HomeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5734fa15",
  null
  
)

export default component.exports